module.exports = __webpack_public_path__ + "media/theme/SP_HITW_open4-1683d275.png";